"use client"

interface ScrimProps {
  onDismiss: () => void
  label: string
  tone?: "strong" | "veil"
  // Callers own the inset: a mega menu dims from below the bar, a full overlay from 0.
  className?: string
  anchored?: boolean
}

// The dim behind a panel that is not a Sheet. It is a button so a press on it
// dismisses and a screen reader can reach the same escape, which a div with an
// onClick gives neither of.
export const Scrim = ({ onDismiss, label, tone = "strong", className, anchored = false }: ScrimProps) => (
  <button
    type="button"
    aria-label={label}
    onClick={onDismiss}
    className={`motion-safe:animate-fade-in ${anchored ? "absolute" : "fixed"} cursor-default ${tone === "veil" ? "bg-scrim backdrop-blur-md" : "bg-scrim-strong"} ${className ?? ""}`}
  />
)
